export default __webpack_public_path__ + "static/media/Substrates-Section-Hub.5c38130d.jpg";